import { render, staticRenderFns } from "./LivingOptionTags.vue?vue&type=template&id=10c163de&scoped=true"
import script from "./LivingOptionTags.vue?vue&type=script&lang=js"
export * from "./LivingOptionTags.vue?vue&type=script&lang=js"
import style0 from "./LivingOptionTags.vue?vue&type=style&index=0&id=10c163de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c163de",
  null
  
)

export default component.exports